import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./SampleMenuListComponent.module.css";
import { sampleMenuActions } from "../../../store/slices/menu-slices";
import SampleMenuPacksSingleComponent from "../SampleMenuPacksSingleComponent/SampleMenuPacksSingleComponent";

const SampleMenuListComponent = ({ setIsOpen }) => {
  const dispatch = useDispatch();
  const { sampleMenuPacksArray, trigger } = useSelector(
    (store) => store.sampleMenu
  );
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    dispatch(sampleMenuActions.getAllSampleMenuPacks());
  }, [trigger, dispatch]);

  const grouped = useMemo(() => {
    if (!sampleMenuPacksArray?.length) return [];

    const map = new Map();

    for (const pack of sampleMenuPacksArray) {
      const cat = pack.packCategory;
      const key = cat?.id ?? '__none__';

      if (!map.has(key)) {
        map.set(key, { category: cat ?? null, packs: [] });
      }
      map.get(key).packs.push(pack);
    }

    const groups = Array.from(map.values());

    groups.sort((a, b) => {
      if (!a.category && b.category) return 1;
      if (a.category && !b.category) return -1;
      return 0;
    });

    return groups;
  }, [sampleMenuPacksArray]);

  return (
    <div className={css.wrap}>
      {grouped.map(({ category, packs }) => (
        <div key={category?.id ?? '__none__'} className={css.categoryGroup}>
          <div className={css.categoryHeader}>
            {category?.icon && (
              <img
                src={category.icon}
                alt=""
                className={css.categoryIcon}
              />
            )}
            <span className={css.categoryName}>
              {category
                ? (category.name[currentLanguage] || category.name['en'])
                : 'Uncategorized'}
            </span>
            <span className={css.categoryCount}>{packs.length}</span>
            <div className={css.categoryDivider} />
          </div>

          {packs.map((obj) => (
            <SampleMenuPacksSingleComponent
              key={obj.id}
              pack={obj}
              setIsOpen={setIsOpen}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default React.memo(SampleMenuListComponent);
